import { createRouter, createWebHashHistory } from "vue-router";

import Layout from "@/views/Layout.vue";
import { applyRouteScroll, scheduleScrollToTop, scrollToHashTarget } from "@/utils/routeScroll";

const routes = [
  {
    path: "/",
    name: "主页",
    redirect: "/dashboard",
    meta: {
      title: "主页",
    },
  },
  {
    path: "/dashboard",
    name: "dashboard",
    component: Layout,
    redirect: "/dashboard/index",
    meta: {
      title: "主页",
    },
    children: [
      {
        path: "index",
        name: "index",
        component: () => import("@/views/home/index.vue"),
        meta: {
          title: "主页",
        },
      },
      {
        path: "business",
        name: "business",
        component: () => import("@/views/business/index.vue"),
      },
      {
        path: "newsroom",
        name: "newsroom",
        component: () => import("@/views/newsroom/newsroom.vue"),
      },
      {
        path: "newsroomDetail",
        name: "newsroomDetail",
        component: () => import("@/views/newsroom/details.vue"),
      },
      {
        path: "contact",
        name: "contact",
        component: () => import("@/views/home/contact.vue"),
      },
      {
        path: "about",
        name: "about",
        component: () => import("@/views/about/who-we-are.vue"),
      },
      {
        path: "products",
        name: "products",
        component: () => import("@/views/products/index.vue"),
      },
      {
        path: "products/details",
        name: "details",
        component: () => import("@/views/products/details.vue"),
      },
      {
        path: "relocation",
        name: "relocation",
        component: () => import("@/views/relocation/index.vue"),
      },
    ],
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return applyRouteScroll(to, from).then(() => false);
  },
});

router.afterEach((to, from) => {
  if (to.hash && to.name === "index") {
    // 首页异步组件渲染完成后补一次锚点定位（避免 scrollBehavior 过早执行）
    scrollToHashTarget(to.hash, { behavior: "smooth", retries: 24, interval: 100 });
    setTimeout(() => {
      scrollToHashTarget(to.hash, { behavior: "auto", retries: 8, interval: 80 });
    }, 400);
    return;
  }
  if (to.hash) {
    return;
  }
  if (!from || to.path === from.path) {
    return;
  }
  scheduleScrollToTop();
});

export default router;
